/*
 * Import common js to use common function in this javascript file
 */
import { searchByTableColumns } from "./common";

// Initialize localstorage object
localStorage.positions = "{}";
var sPositions = localStorage.positions,
    positions = JSON.parse(sPositions);
window.$(document).ready(function() {

    var setting_data = window.$('#setting_data').val();
    if (setting_data && setting_data != "[]" && setting_data != '') {
        localStorage.positions = setting_data
        positions = JSON.parse(setting_data);
    }
    window.$.each(positions, function(id, pos) {
        window.$("#" + id).css(pos)
    })
    if($("#accessrole").val() == ''){
    window.$(".table_area .table_container").draggable({
        containment: "#drop",
        cursor: "move",
        scroll: false,
        stop: function(event, ui) {
            if (!window.$(this).hasClass('dragged_object')) {
                var left = window.$(this).offset().left - window.$('#drop').offset().left;
                var top = window.$(this).offset().top - window.$('#drop').offset().top;

                // Convert to percentage
                left = (100 * parseFloat(left / parseFloat(window.$('#drop').width()))) + "%";
                top = (100 * parseFloat(top / parseFloat(window.$('#drop').height()))) + "%";

                positions[this.id] = { "top": top, "left": left };
                localStorage.positions = JSON.stringify(positions);

                window.$('#drop').append(window.$(this));
                window.$('#origin').remove(window.$(this));
                window.$(this).addClass('dragged_object');
                window.$(this).prepend('<span class="close">&times;</span>');
                window.$.each(positions, function(id, pos) {
                    window.$("#" + id).css(pos)
                })
            } else {
                // Convert to percentage
                left = (100 * parseFloat($(this).position().left / parseFloat($(this).parent().width()))) + "%";
                top = (100 * parseFloat($(this).position().top / parseFloat($(this).parent().height()))) + "%";

                positions[this.id] = { "top": top, "left": left };
                localStorage.positions = JSON.stringify(positions);
            }
        }
    });
}else{
    window.$("#drop").find('span.close').remove();
}
});

/**
 * Filter tables based on table type
 */
window.$(".table_area .get_tables").on('click', function(e) {
    window.$('.no_available_table_message').addClass('d-none');

    window.$('.get_tables').removeClass('active');
    window.$(this).addClass('active');

    // Add hide class to all li of available tables
    window.$(".available_tables span").not('.dragged_object').addClass("d-none");
    var tableType = window.$(this).attr('data-tableType');
    window.$('.' + tableType).not('.dragged_object').removeClass('d-none');
    if (window.$('.' + tableType).not('.dragged_object').length < 1) {
        window.$('.no_available_table_message').removeClass('d-none');
    }
});

/**
 * Remove tables from area
 */
window.$(document).on('click', ".table_container .close", function(e) {
    var table_container = window.$(this).parents('.table_container');
    window.$('#origin').prepend(table_container);
    window.$('#drop').remove(table_container);
    window.$(table_container).removeClass('dragged_object');
    window.$(table_container).removeAttr('style');
    window.$(this).remove();
    delete positions[table_container.attr('id')];
    localStorage.positions = JSON.stringify(positions);

    var tableType = window.$(".get_tables.active").attr('data-tableType');
    if (!window.$(table_container).hasClass(tableType)) {
        window.$(table_container).addClass('d-none');
    } else {
        window.$('.no_available_table_message').addClass('d-none');
    }
});

/**
 * Area store
 */
window.$(".saveAreas").on('click', function(e) {

    e.preventDefault();
    var formData = new FormData($("form#areasForm")[0]);

    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveAreas').attr('disabled', 'disabled');

    window.axios({
            method: "post",
            url: window.$(".areasForm").attr('action'),
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.saveAreas').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }else if (error.response.status == 401) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Area update
 */
window.$(".updateAreasBtn").on('click', function(e) {

    e.preventDefault();
    var formDataUpdate = new FormData(window.$("form#areasUpdateForm")[0]);
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateAreas').attr('disabled', 'disabled');

    window.axios({
            method: "POST",
            url: window.$(".areasUpdateForm").attr('action'),
            data: formDataUpdate,
            //headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.updateAreas').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    if(key == 'name'){
                        window.$('#' + key + '-error').text(value[0]);
                    }else if(key == 'blueprinterror'){
                        window.toastr.error(value[0],'');
                    }
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            } else if (error.response.status == 401) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Tables table listing
 */

var table = window.$('.areasTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".areasTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false },
        { data: 'name', name: 'name' },
        { data: 'priority', name: 'priority' },
        { data: 'blueprint', name: 'blueprint' },
        { data: 'status', name: 'status', orderable: false, className: "status" },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ],
    columnDefs: [{
        targets: [3],

    }]
});

// change status of guest tag
window.$(document).on('click', '.areasTable .status_checkbox', function(e) {

    window.$(".error").html('');
    window.toastr.remove();

    var id = window.$(this).closest("tr").attr('id');
    if (typeof id !== "undefined" && id !== '') {
        var status = (window.$(this).is(':checked')) ? 'on' : 'off';
        let t = window.$(this);
        var queryString = '/' + id;

        window.axios({
                method: "put",
                url: window.$(".areasTable").attr('link') + queryString,
                data: {
                    'id': id,
                    'status': status,
                    'update_status': true
                }
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                if (error.response.status == 401) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                    if(status == 'on'){
                        window.$(t).prop('checked',false);
                    }else if(status == 'off'){
                        window.$(t).prop('checked',true);
                    }
                }
            })
    }
});

// save area position
window.$(document).on('click', '.areasForm .saveBlueprint', function(e) {

    window.$(".error").html('');
    window.toastr.remove();
    var thisEvent = window.$(this);
    var id = window.$(this).attr('data-id');
    if (typeof id !== "undefined" && id !== '') {
        var queryString = '/' + id;

        // Get the position from localstorage
        var positions = JSON.parse(localStorage.positions || "{}");

        window.axios({
                method: "put",
                url: window.$(".areasForm").attr('action') + queryString,
                data: {
                    'id': id,
                    'positions': positions,
                    'update_status': true
                }
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
                if (thisEvent.hasClass('refresh_area')) {
                    location.reload();
                }
            })
    }
});

window.$(document).ready(function() {
    // Setup - add a text input to each footer cell
    var excluded_columns = [3, 4, 5];
    searchByTableColumns(table, '#areasTable', excluded_columns);
});
window.$(document).on('click','#label-blueprint',function(e){
    if(window.$("#blueprintChangeFlag").val() == 1){
        e.preventDefault();
        window.toastr.error('Please remove tables from the original blueprint before adding a new blueprint');
    }else{
        window.$(this).unbind(e);
    }
});